import _ from "lodash";
import React, { ReactNode } from "react";
import CreatableSelect from "react-select/creatable";
import { v4 as uuidv4 } from "uuid";

interface Option {
  value: string;
  label: string;
}

interface Props {
  title?: string;
  placeholder: string;
  createLabel?: string;
  className?: string;
  options: Option[];
  onCreateOption?: any;
  disabled?: boolean;
  onChange: (_: any) => void;
  val: string;
  error?: boolean;
  isClearable?: boolean;
  secondaryElement?: ReactNode;
}

export default function UncontrolledInputCreatableSelect({
  title,
  disabled,
  placeholder,
  createLabel,
  className,
  options,
  error,
  onCreateOption,
  onChange,
  val,
  isClearable = true,
  secondaryElement,
}: Props): JSX.Element {
  const formInputId = React.useMemo(() => {
    return uuidv4();
  }, []);

  return (
    <>
      {title ? (
        <label htmlFor={formInputId} className="mb-1 block text-sm font-medium  leading-5 text-gray-700">
          <div className="flex flex-row gap-2 items-center">
            {title}
            {error ? <span className="text-red-500 "> required</span> : null}
            {secondaryElement}
          </div>
        </label>
      ) : null}

      <div className="remove-input-txt-border">
        <CreatableSelect
          isClearable={isClearable}
          isDisabled={disabled}
          formatCreateLabel={(inputValue: string) => {
            return `${createLabel ? createLabel : "Add"}: ${inputValue}`;
          }}
          placeholder={placeholder}
          onChange={(option) => (option ? onChange(option.value) : onChange(null))}
          onCreateOption={onCreateOption}
          value={options.find(({ value }) => value === val) ?? { value: val, label: val }}
          options={options}
          theme={(theme) => ({
            ...theme,
          })}
          styles={{
            control: (styles) => ({
              ...styles,
              borderRadius: 2,
              borderColor: "#9ca3af",
            }),
          }}
          className={`
            ${className}
            sm:text-sm sm:leading-5 rounded
            ${error ? "border-red-200 outline-none ring ring-red-200 ring-opacity-50" : ""}`}
        />
      </div>
    </>
  );
}
